(function() {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  function attachZoom(stage) {
    if (stage.dataset.nbZoomBound) return;
    stage.dataset.nbZoomBound = 'true';

    stage.addEventListener('mouseenter', function() {
      if (stage.querySelector('img')) {
        stage.classList.add('is-zoomed');
      }
    });

    stage.addEventListener('mouseleave', function() {
      stage.classList.remove('is-zoomed');
      var img = stage.querySelector('img');
      if (img) img.style.transformOrigin = '50% 50%';
    });

    stage.addEventListener('mousemove', function(e) {
      var img = stage.querySelector('img');
      if (!img) return;
      var rect = stage.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  function init() {
    var stages = document.querySelectorAll('.nb-pa-lightbox-stage');
    stages.forEach(attachZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
